import React, { useState } from "react";
import PrimaryButton from "../components/ui/button/PrimaryButton";
import SecondaryButton from "../components/ui/button/SecondaryButton";
import SectionHeader from "../components/ui/sectionHeader/SectionHeader";
import SectionTitle from "../components/ui/sectionTitle/SectionTitle";
import TextInput from "../components/ui/input/TextInput";
import TextInputSecondary from "../components/ui/input/TextInputSecondary";
import TabComp from "../components/ui/tabcomp/TabComp";
import FileUpload from "../components/ui/draganddrop/FileUpload";
import PlanButton from "../components/ui/planbutton/PlanButton";

const ComponentsPage = () => {
  const [formData, setFormData] = useState({ mobile: "", name: "" });
    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }; 
    const handleClick = () => {
      alert("Primary Button Clicked!");
    };
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState(""); 
    const handleEmailChange = (e) => {
      setEmail(e.target.value);
    };

  const handleMobileChange = (e) => {
    setMobile(e.target.value);
  };
  // Tab data for dynamic content
  const tabsData = [
    { title: "Plate & Civil Id", content: <p>Plate & Civil Id</p> },
    { title: "Plate & Mobile No", content: <p>Plate & Mobile No</p> },
    { title: "Quote No", content: <p>Quote No</p> },
  ];

  return (
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-12">
          <h4>Components List</h4>
        </div>
      </div>

      {/* Primary Button */}
      <div className="row mb-5">
        <div className="col-md-6">
          <h4 className="border-bottom border-primary">Primary Button</h4>
          <div className="my-4">
            <PrimaryButton label="Get Quote" onClick={handleClick} />
          </div>
        </div>
      </div>

      {/* secondary Button */}
      <div className="row mb-5">
        <div className="col-md-6">
          <h4 className="border-bottom border-primary">Secondary Button</h4>
          <div className="my-4">
            <SecondaryButton
              label="Comprehensive Insurance"
              onClick={handleClick}
            />
          </div>
        </div>
      </div>

      {/* Section Header */}
      <div className="row mb-5">
        <div className="col-md-12">
          <h4 className="border-bottom border-primary">Section Header</h4>
          <div className="my-4">
            <SectionHeader title="Motor Insurance" />
          </div>
        </div>
      </div>

      {/* Section Title */}
      <div className="row mb-5">
        <div className="col-md-12">
          <h4 className="border-bottom border-primary">Section Title</h4>
          <div className="my-4">
            <SectionTitle title="Buy Policy" />
          </div>
        </div>
      </div>

      {/* Text Input */}
      <div className="row mb-5">
        <div className="col-md-4">
          <h4 className="border-bottom border-primary">Text Input</h4>
          <div className="my-4">
            <TextInput
              label="Mobile Number"
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter your mobile number"
              required={true}
            />
            <TextInput
              label="Full Name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
            />
          </div>
        </div>
      </div>

      {/* Text Input TextInputSecondary*/}
      <div className="row mb-5">
        <div className="col-md-4">
          <h4 className="border-bottom border-primary">Text Input Secondary</h4>
          <div className="my-4">
            <TextInputSecondary
              label="Email Address"
              name="email"
              type="email"  
              value={email}
              onChange={handleEmailChange}
              placeholder="Enter your email"
              required
            />

            {/* for mobile number */}
            <TextInputSecondary
              label="Mobile Number"
              name="mobile"
              type="tel"  
              value={mobile}
              onChange={handleMobileChange}
              placeholder="Enter your mobile number"
              required
            />
          </div>
        </div>
      </div>

      {/* Tab Section */}
      <div className="row mb-5">
        <div className="col-md-12">
          <h4 className="border-bottom border-primary">Tab</h4>
          <div className="my-4">
            <TabComp tabs={tabsData} />
          </div>
        </div>
      </div>

      {/* Drag & Drop Section */}
      <div className="row mb-5">
        <div className="col-md-12">
          <h4 className="border-bottom border-primary">Drag & Drop</h4>
          <div className="my-4">
            <FileUpload
              onFileSelect={(files) => console.log("Selected Files:", files)}
            />
          </div>
        </div>
      </div>

      {/* Plan Selcet Button */}
      <div className="row mb-5">
        <div className="col-md-12">
          <h4 className="border-bottom border-primary">Plan select Button</h4>
          <div className="my-4">
            <PlanButton
              text="Basic + Medex + Driver + Family (PAB) + UAE"
              infoText="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam"
              onClick={() => alert("Plan selected!")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComponentsPage;
